import React, {useCallback, useState} from "react";
import {ConfigProvider, message} from "antd";
import {UploadDeliveryProviderDriverModal} from "./UploadDeliveryProviderDriverModal.jsx";
import {RoundedTable, SquareButton} from "../../../../components/index.jsx";
import {
    addDeliveryProviderDriver,
    updateDeliveryProviderDriver
} from "../../../../api/deliveryProvider/adminDeliveryProvider.js";
import {columns} from "./columns.jsx";
import {useRequest} from "../../../../utils/hooks.jsx";
import "./delivery-provider-drivers.css";

export const DeliveryProviderDrivers = ({deliveryProviderId}) => {
    const [visibleCreationDeliveryProviderDriver, setVisibleCreationDeliveryProviderDriver] = useState(false);
    const [editDeliveryProviderDriver, setEditDeliveryProviderDriver] = useState({});

    const [deliveryProviderDrivers, isLoading, error, fetchDrivers] = useRequest(
        `/admin/api/deliveryProviders/${deliveryProviderId}/drivers`,
        "GET",
        null,
        [deliveryProviderId],
        !!deliveryProviderId,
        null,
        []
    );

    const onSaveDriver = useCallback(
        async values => {
            try {
                const {error} = editDeliveryProviderDriver?.driverId
                    ? await updateDeliveryProviderDriver(
                          deliveryProviderId,
                          editDeliveryProviderDriver?.driverId,
                          values
                      )
                    : await addDeliveryProviderDriver(deliveryProviderId, values);

                if (error) {
                    return false;
                }

                fetchDrivers();
            } catch (error) {
                message.error(error?.message, 10);
                return false;
            }

            return true;
        },
        [deliveryProviderId, editDeliveryProviderDriver?.driverId, fetchDrivers]
    );

    const onEditDriver = useCallback(deliveryProviderDriver => {
        setVisibleCreationDeliveryProviderDriver(true);
        setEditDeliveryProviderDriver(deliveryProviderDriver);
    }, []);

    const onCloseEditDriver = useCallback(() => {
        setVisibleCreationDeliveryProviderDriver(false);
        setEditDeliveryProviderDriver({});
    }, []);

    return (
        <div className="delivery-providers-drivers-page">
            <ConfigProvider direction="rtl">
                <SquareButton
                    className="delivery-provider-driver-upload-btn"
                    onClick={() => setVisibleCreationDeliveryProviderDriver(true)}>
                    הוספת נהג
                </SquareButton>
            </ConfigProvider>

            <UploadDeliveryProviderDriverModal
                visible={visibleCreationDeliveryProviderDriver}
                onClose={onCloseEditDriver}
                onSave={onSaveDriver}
                deliveryProviderDriver={editDeliveryProviderDriver}
            />

            <RoundedTable
                scroll={{x: 1240}}
                loading={isLoading}
                dataSource={deliveryProviderDrivers ?? []}
                columns={columns(onEditDriver)}
            />
        </div>
    );
};
